import { useState } from "react";
import { css } from "styled-components";
import { useHistory } from "react-router-dom";
import { AddressPicker, StackedAddressPicker, media } from "@nested/brand";
import { onboardingCtaHandler } from "@nested/brand/src/components/AddressPicker";
import { blogWrapperStyles } from "../../../components/Blog/Breadcrumbs";

const wrapperStyle = css`
  background-color: ${({ theme }) => theme.palette.hague};
  border-radius: 10px;
  color: white;
  padding: 15px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const headingStyle = css`
  color: white;
  font-size: 18px;
  margin: 0;
  line-height: 22px;
  font-weight: 500;
`;

const paragraphStyle = css`
  font-size: 14px;
  line-height: 17px;
  margin-top: 10px;
  margin-bottom: 20px;

  color: white;
  ${media.tablet`
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 15px;
  `}
`;

const tabletUp = css`
  display: none;
  ${media.tablet`
    display: block;
  `}
`;

const mobileOnly = css`
  display: block;
  ${media.tablet`
    display: none;
  `}
`;

export const PostcodeCTA = ({ heading, placeholder, text, button_label }) => {
  const [address, setAddress] = useState();
  const history = useHistory();
  const onSubmit = onboardingCtaHandler("blog-address-cta", history);
  return (
    <div css={blogWrapperStyles}>
      <div css={wrapperStyle}>
        <h3 css={headingStyle}>{heading}</h3>
        <p css={paragraphStyle}>{text}</p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit({
              "blog-address-cta": address,
            });
          }}
        >
          <div css={tabletUp}>
            <AddressPicker
              includeBlacklisted
              includeNotInServicedArea
              placeholder={placeholder}
              submitButtonText={button_label}
              withPin
              value={address}
              onChange={setAddress}
            />
          </div>
          <div css={mobileOnly}>
            <StackedAddressPicker
              includeBlacklisted
              includeNotInServicedArea
              placeholder={placeholder}
              submitButtonText={button_label}
              withPin
              value={address}
              onChange={setAddress}
            />
          </div>
        </form>
      </div>
    </div>
  );
};
